import React, { useEffect, useRef, useState } from 'react';
import { useI18n } from '../useI18n.js';
import { serverUrl } from '../socket';

// Roue de selection d'un mashup (Cover + Studio) : le pool defile et s'arrete sur
// le mashup assigne. A l'arret, un extrait pris au milieu du mashup est joue en
// fond quelques secondes pour donner de la vie a l'animation.
export function MashupWheel({ assign }) {
  const { t } = useI18n();
  const pool = assign?.pool || [];
  const [cur, setCur] = useState(0);
  const [done, setDone] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    if (!pool.length) { setDone(true); return; }
    let i = 0; let stop = false; let timer = null;
    const start = performance.now();
    const wheelMs = assign?.wheelMs || 6000;
    const tick = () => {
      if (stop) return;
      i = (i + 1) % pool.length; setCur(i);
      const el = performance.now() - start;
      if (el >= wheelMs) { setDone(true); return; }
      timer = setTimeout(tick, 45 + Math.pow(el / wheelMs, 2.2) * 300);
    };
    timer = setTimeout(tick, 45);
    return () => { stop = true; if (timer) clearTimeout(timer); };
  }, [assign]);

  useEffect(() => {
    if (!done || !assign?.audioUrl) return;
    const a = audioRef.current; if (!a) return;
    let stopT = null;
    a.src = `${serverUrl}${assign.audioUrl}`;
    a.onloadedmetadata = () => {
      const d = a.duration || 0;
      a.currentTime = Math.max(0, d / 2);
      a.volume = 0.85;
      a.play().catch(() => {});
      stopT = setTimeout(() => { try { a.pause(); } catch {} }, 4500);
    };
    a.load();
    return () => { if (stopT) clearTimeout(stopT); try { a.pause(); } catch {} };
  }, [done, assign]);

  const shown = done ? assign?.landsOn : (pool[cur] || '');
  return (
    <div className="cover-wheel">
      <audio ref={audioRef} preload="none" style={{ display: 'none' }} />
      <div className="cw-label">{done ? (t('coverYourMashup') || 'Ton mashup') : (t('coverSpinning') || 'La roue tourne...')}</div>
      <div className={`cw-name${done ? ' locked' : ''}`}>{shown || '...'}</div>
      {done && assign?.author && <div className="cw-author">{assign.author}</div>}
    </div>
  );
}
